import { render } from "./NavigationDrawer.vue?vue&type=template&id=1be0c863&scoped=true"
import script from "./NavigationDrawer.vue?vue&type=script&lang=js"
export * from "./NavigationDrawer.vue?vue&type=script&lang=js"

import "./NavigationDrawer.vue?vue&type=style&index=0&id=1be0c863&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1be0c863"

export default script